// extracted by mini-css-extract-plugin
export default {"container":"Home_container__MGYYT","image":"Home_image__T5Jrw","divEsperats":"Home_divEsperats__U8uqF","spanEsperats2":"Home_spanEsperats2__y6P7s"};